import _ from 'lodash';
import React, { useState } from 'react';
import autobind from 'autobind-decorator';

import Field from './field';

export default (props) => {
    const {
        fieldKey,
        label,
        isCheckedValue,
        register,
        inputClass,
        uncheckedLabel = 'Inactive',
        checkedLabel = 'Active'
    } = props;

    const [isChecked, setChecked] = useState(isCheckedValue);

    return (
        <div className="grid-x align-middle">
            <div className="cell small-4 text-center">
                <span>{ uncheckedLabel }</span>
            </div>

            <div className="cell shrink">
                <div className={inputClass + " switch margin-0"}>
                    <input
                        {...register}
                        className="switch-input"
                        id={fieldKey}
                        type="checkbox"
                        name={fieldKey}
                        checked={ isChecked }
                        onChange={
                            ({ target }) => { setChecked(target.checked); }
                        }
                    />

                    <label className="switch-paddle" htmlFor="exampleSwitch">
                        <span className="show-for-sr">{ label }</span>
                    </label>
                </div>
            </div>

            <div className="cell small-4 text-center">
                <span>{ checkedLabel }</span>
            </div>
        </div>
    );
}
